import type { Breadcrumb, Event } from '@sentry/react';

const scrubUrl = (value: unknown) =>
  typeof value === 'string'
    ? value.replace(
        /(^|[?&])(token|tenant_id|auth_code)=[^&#]*/g,
        '$1$2=[redacted]',
      )
    : value;

const scrubStringValues = (data: Record<string, unknown> | undefined) => {
  if (data == null) {
    return;
  }
  for (const key of Object.keys(data)) {
    data[key] = scrubUrl(data[key]);
  }
};

export const scrubSentryBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => {
  if (breadcrumb.data) {
    breadcrumb.data.from = scrubUrl(breadcrumb.data.from);
    breadcrumb.data.to = scrubUrl(breadcrumb.data.to);
    breadcrumb.data.url = scrubUrl(breadcrumb.data.url);
  }
  return breadcrumb;
};

export const scrubSentryEvent = (event: Event): Event => {
  scrubStringValues(event.request?.headers);
  if (event.request?.url) {
    event.request.url = scrubUrl(event.request.url) as string;
  }
  event.breadcrumbs?.forEach(scrubSentryBreadcrumb);
  event.spans?.forEach(span => {
    if (typeof span.description === 'string') {
      span.description = scrubUrl(span.description) as string;
    }
    scrubStringValues(span.data);
  });
  scrubStringValues(event.contexts?.trace?.data);
  return event;
};
